import React from 'react';
import ServiceDetail from '@/components/services/ServiceDetail';

export default function GarageDoorInstallation() {
  return <ServiceDetail serviceKey="installation" />;
}